import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const createBucketGroup = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation createBucketGroup($caseTypeId: Int!, $name: String!, $position: Int!, $buckets: [Int]!) {
            createBucketGroup(caseTypeId: $caseTypeId, name: $name, position: $position, buckets: $buckets) {
            id
            name
            position
            buckets
            error
            message
          }
        }
      `),
      variables: { caseTypeId: data.caseTypeId, name: data.name, position: data.position, buckets: data.buckets }
    })
  return response.data.createBucketGroup
}

export const updateBucketGroup = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
          mutation updateBucketGroup($groupId: Int!, $name: String, $position: Int, $buckets: [Int]!) {
            updateBucketGroup(groupId: $groupId, name: $name, position: $position, buckets: $buckets) {
              id
              name
              position
              buckets
              error
              message
            }
          }
        `),
      variables: { groupId: data.id, name: data.name, position: data.position, buckets: data.buckets }
    })
  return response.data.updateBucketGroup
}

export const deleteBucketGroup = async (id) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation deleteBucketGroup($groupId: Int!) {
          deleteBucketGroup(groupId: $groupId) { error message }
        }
      `),
      variables: { groupId: id }
    })
  return response.data.deleteBucketGroup
}
